export const regex = '^[\\w.%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';
export default regex;
